import { render, staticRenderFns } from "./MerchantPickupPoints.vue?vue&type=template&id=2a638834"
import script from "./MerchantPickupPoints.vue?vue&type=script&lang=js"
export * from "./MerchantPickupPoints.vue?vue&type=script&lang=js"
import style0 from "./MerchantPickupPoints.vue?vue&type=style&index=0&id=2a638834&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports